<template>
    <rkm-modal
        extra-large
        hide-footer
        ref="RkmModal"
        title="Atendimentos"
    >
        <List
            v-if="model"
            :data="{model}"
            @saved="load"
            class="tabela-paciente"
        />

        <rkm-row class="mt-3">
            <rkm-col>
                <p class="m-0">
                    <span class="legend-color purple" /> Paciente em óbito<br>
                    <span class="legend-color danger" /> Cadastro bloqueado<br>
                    <span class="legend-color orange" /> Paciente provisório ou temporário<br>
                    <span class="legend-color brown" /> Paciente não munícipe<br>
                    <span class="legend-color warning" /> Paciente sem CPF e CNS
                </p>
            </rkm-col>
        </rkm-row>
    </rkm-modal>
</template>

<script>
// Components.
import List from './List'

// Mixins.
import {error, repository, stringCase} from '@/mixins'

// Vuex.
import {mapActions} from 'vuex'

export default {
    components: {List},
    created() {
        this.repositories = {
            gerenciamentoDiario: this.getConectaSusRepository('ambulatorio.gerenciamentoDiario'),
        }
    },
    data: () => ({
        model: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open() {
            this.$refs.RkmModal.show()
            this.load()
        },
        load() {
            this.setLoading()

            this.repositories.gerenciamentoDiario.list({origem: 'atendimento'})
                .then(response => this.model = Object.assign(response.data.model))
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
    },
    mixins: [error, repository, stringCase],
}
</script>

<style scoped>
.legend-color {
    display: inline-block;
    width: 12px;
    height: 12px;
    border-radius: 2px;
    margin-right: 4px;
}
.legend-color.purple {
    background-color: #6f42c1;
}
.legend-color.danger {
    background-color: var(--danger);
}
.legend-color.orange {
    background-color: #F28C28;
}
.legend-color.brown {
    background-color: #6F4E37;
}
.legend-color.warning {
    background-color: var(--warning);
}

.tabela-paciente >>> .table-orange {
    border-color: #F28C28;
    background-color: #FFE0B2;
}

.tabela-paciente >>> .table-brown {
    border-color: #6F4E37;
    background-color: #D2B48C;
}

.tabela-paciente >>> .table-purple {
    border-color: #6f42c1;
    background-color: #E1D4F2;
}
</style>